import { ApplicationMerchantConfigurations, OPTIMIZATION_TYPE, Team } from '@bringg/types';

const getOptimizationType = (team: Team, configuration: ApplicationMerchantConfigurations): OPTIMIZATION_TYPE => {
	const hasCombinedOptimization = team.feature_flags?.combined_optimization_rollout;

	return hasCombinedOptimization ? OPTIMIZATION_TYPE.COMBINED : configuration?.data?.optimization_type;
};

export const optimizationTypeProvider = { get: getOptimizationType };
